module.exports = __webpack_public_path__ + "img/4.ac51b48b.png";